module.exports = __webpack_public_path__ + "assets/img/企业微信-01e0afd6.png";